import Marquee from "react-fast-marquee";

export default function UrgencyBanner({ text = "DROP IN PROGRESS // 9PM IST // ONE PRODUCT // 2 MIN ONLY // BUY OR LOSE //" }) {
  return (
    <div className="border-y border-[#E5E1D8] brutal-marquee overflow-hidden">
      <Marquee speed={60} gradient={false} className="py-2.5">
        {Array(8).fill(text).map((t, i) => (
          <span key={`urgency-${i}`} className="mx-6">{t}</span>
        ))}
      </Marquee>
    </div>
  );
}
